<div [ngClass]="'loader loader-' + size"></div>
